import { render } from "./ContactModal.vue?vue&type=template&id=b2f8b8f6&scoped=true"
import script from "./ContactModal.vue?vue&type=script&lang=js"
export * from "./ContactModal.vue?vue&type=script&lang=js"

import "./ContactModal.vue?vue&type=style&index=0&id=b2f8b8f6&scoped=true&lang=scss"

import exportComponent from "/home/forge/olyo.io/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2f8b8f6"]])

export default __exports__